import type { PerformanceTier } from '@/device/deviceConfig'
import type { AmznStreamingOptions } from '@amzn/vinyl-amzn'

export interface PerformanceProfile {
    readonly uhdAllowed: boolean
    readonly reduceMotionByDefault: boolean
    /** The densest image and canvas scaling requested, whatever the screen's `devicePixelRatio`. */
    readonly maxPixelRatio: number
    /** Whether routes and next pages are fetched ahead of the user asking for them. */
    readonly prefetch: boolean
    /** Route views kept across all routes; null keeps each route's own cache. */
    readonly routeViewCacheCapacity: number | null
}

const profiles = {
    high: {
        uhdAllowed: true,
        reduceMotionByDefault: false,
        maxPixelRatio: 2,
        prefetch: true,
        routeViewCacheCapacity: null,
    },
    medium: {
        uhdAllowed: false,
        reduceMotionByDefault: false,
        maxPixelRatio: 2,
        prefetch: true,
        routeViewCacheCapacity: null,
    },
    low: {
        uhdAllowed: false,
        reduceMotionByDefault: true,
        maxPixelRatio: 1,
        prefetch: false,
        routeViewCacheCapacity: 1,
    },
} as const satisfies Record<PerformanceTier, PerformanceProfile>

export function performanceProfile(tier: PerformanceTier): PerformanceProfile {
    return profiles[tier]
}

export function constrainStreamingOptions(
    options: AmznStreamingOptions,
    tier: PerformanceTier
): AmznStreamingOptions {
    return performanceProfile(tier).uhdAllowed || !options.uhdEnabled
        ? options
        : { ...options, uhdEnabled: false }
}
